import React, { Component } from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Row,
    Col
} from "reactstrap";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import NumberFormat from 'react-number-format';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { confirmAlert } from 'react-confirm-alert';
const headerStyle = {
    padding: '0.5rem',
};
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as common from '../../lib/common'
import * as khachhangConstant from './constants'

class ViewTraThuong extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {}
        };
    }
    handleControlChange = (e) => {
        let { item } = this.state
        item[e.target.name] = e.target.value
        this.setState({ item })
    }
    handleDateChange = (date) => {
        let { item } = this.state
        item.NgayTraThuong = date
        this.setState({ item })
    }
    handleSoDiemChange = (v) => {
        let floatValue = v.floatValue || 0;
        let { item } = this.state
        if (floatValue > item.MaxValue) {
            floatValue = item.MaxValue
        }
        item.SoDiemTraThuong = floatValue
        this.setState({ item });
    }
    handleSoTienChange = (v) => {
        const floatValue = v.floatValue || 0;
        let { item } = this.state
        if (floatValue >= 0) {
            item.SoTienTraThuong = floatValue
            this.setState({ item });
        }
    }
    confirmTraThuong = (e, loaiTraThuongText) => {
        let { item } = this.state
        if (item.SoDiemTraThuong > 0 && item.SoTienTraThuong > 0) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className='custom-ui'>
                            <h1>THÔNG BÁO?</h1>
                            <p>Xác nhận trả thưởng 
                                <b className="text-danger">{parseFloat(item.SoDiemTraThuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</b>
                                &nbsp;{loaiTraThuongText} tương ứng với tiền quy đổi&nbsp;
                                <b className="text-danger">{parseFloat(item.SoTienTraThuong || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</b>&nbsp;₫?
                            </p>
                            <button className="text-danger" onClick={() => {
                                this.handleSaveData();
                                onClose();
                            }}>Đồng ý</button>
                            <button onClick={() => {
                                onClose()
                            }}>Hủy bỏ</button>
                        </div>
                    )
                }
            });
        }
        else {
        }
    }

    handleSaveData = () => {
        let { item } = this.state
        this.props.TraThuongKhachHang(item);
    }
    numberOnclick = (e) => {
        e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
    }
    closePopupHandle = () => {
        this.props.onClose();
        this.setState({
            item: {}
        });
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.isOpen) {
            this.setState({
                item: nextProps.item
            })
        }
    }
    render() {
        const {
            isRequesting,
            errors,
            messages
        } = this.props
        const { item } = this.state
        const saveEnabled = item.SoDiemTraThuong != 0 && item.SoTienTraThuong != 0
        const isPointReturn = item.LoaiTraThuong === khachhangConstant.LoaiTraThuong.Point
        const loaiTraThuongText = isPointReturn ? "điểm" : "tiền"
        return (
            <div className="animated fadeIn">
                <Modal isOpen={this.props.isOpen} className={'modal-md'}>
                    <ModalHeader style={headerStyle}>TRẢ THƯỞNG KHÁCH HÀNG</ModalHeader>
                    <ModalBody>
                        <BlockUi tag="div" blocking={isRequesting}>
                            <div className="row">
                                <div className="col-sm-12 mb-2">
                                    <span className="text-red">{
                                        item.TenKhachHang ? "Khách hàng: " + item.TenKhachHang : ''}
                                    </span>
                                </div>
                                <div className="col-sm-4">
                                    <FormGroup className="mb-0">
                                        <Label htmlFor="NgayTraThuong">Ngày trả thưởng</Label>
                                        <div>
                                            <DatePicker name="NgayTraThuong" selected={item.NgayTraThuong} onChange={this.handleDateChange.bind(this)} required className={"form-control"} autoComplete="off" dateFormat="DD/MM/YYYY" />
                                        </div>
                                    </FormGroup>
                                </div>
                                <div className="col-sm-4">
                                    <FormGroup className="mb-0">
                                        <Label htmlFor="sodiem">Số {loaiTraThuongText} trả thưởng</Label>
                                        <NumberFormat
                                            name={"SoDiemTraThuong"}
                                            value={item.SoDiemTraThuong || 0}
                                            defaultValue={1}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            type="tel"
                                            maxLength="15"
                                            onClick={this.numberOnclick.bind(this)}
                                            onValueChange={e => this.handleSoDiemChange(e)}
                                            className={"form-control order-input-sl price"} />
                                    </FormGroup>
                                </div>
                                <div className="col-sm-4">
                                    <FormGroup className="mb-0">
                                        <Label htmlFor="soluong">Số tiền quy đổi</Label>
                                        <NumberFormat
                                            name={"SoTienTraThuong"}
                                            value={item.SoTienTraThuong || 0}
                                            defaultValue={1}
                                            thousandSeparator={"."}
                                            decimalSeparator={","}
                                            type="tel"
                                            maxLength="15"
                                            onClick={this.numberOnclick.bind(this)}
                                            onValueChange={e => this.handleSoTienChange(e)}
                                            className={"form-control order-input-sl price"} />
                                    </FormGroup>
                                </div>
                                <div className="col-sm-12">
                                    <div className="text-right"><em className="invalid-feedback font-italic">{common.number2Text(item.SoTienTraThuong)}</em></div>
                                </div>
                                <div className="col-sm-12">
                                    <FormGroup>
                                        <Label htmlFor="ghichu">Ghi chú</Label>
                                        <textarea className="form-control" value={item.GhiChu || ''}
                                         name="GhiChu"
                                         onChange={e => this.handleControlChange(e)}></textarea>
                                    </FormGroup>
                                </div>
                            </div>
                        </BlockUi>
                        <Row>
                            <Col md="12">
                                {!isRequesting && !!errors.length && (
                                    <Errors errors={errors} />
                                )}
                                {!isRequesting && !!messages.length && (
                                    <Messages messages={messages} />
                                )}
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button disabled={!saveEnabled} color="primary" style={{ display: isRequesting ? "none" : "block" }}
                         onClick={e => this.confirmTraThuong(e, loaiTraThuongText)} ><i className="fa fa-save"></i>&nbsp;Trả thưởng</Button>
                        <Button color="secondary" onClick={e => this.closePopupHandle(e)}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
export default ViewTraThuong


// WEBPACK FOOTER //
// ./src/views/KhachHang/_ViewTraThuong.js